import { range } from '@/shared/utils/misc';
import { isValidUkDate } from '@/shared/utils/validation';

const shiftUtc = (date: Date | string, from: boolean) => {
  if (typeof date === 'string') {
    date = new Date(Date.parse(date));
  }

  date = new Date(date.getTime());

  date.setMinutes(date.getMinutes() + date.getTimezoneOffset() * (from ? 1 : -1));

  return date;
};

export const shiftFromUtc = (date: Date | string) => shiftUtc(date, true);

export const shiftToUtc = (date: Date | string) => shiftUtc(date, false);

export const parseIsoDate = (value?: string | null) => {
  if (value) {
    const timestamp = Date.parse(value);

    if (!isNaN(timestamp)) {
      return new Date(timestamp);
    }
  }
};

export const parseUkDate = (value?: string | null) => {
  if (value && isValidUkDate(value)) {
    const [day, month, year] = value.split('/');
    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  }
};

export const formatIsoDate = (date: Date) => date.toISOString().substring(0, 10);

export const randomDate = (from: Date, to: Date) =>
  new Date(new Date(from.getTime() + Math.random() * (to.getTime() - from.getTime())).toISOString().substring(0, 10));

export const randomDates = (from: Date, to: Date, quantity: number) => range(quantity).map(() => randomDate(from, to));

export const datesEqual = (date1: Date, date2: Date) => date1.getTime() === date2.getTime();

export const isDate = (obj: object): obj is Date => typeof obj === 'object' && 'toISOString' in obj;
